import React from 'react';
import useStyles from 'components/NotFoundPage/style';

const NotFoundPage = () => {
  const classes = useStyles();
  const text404 = (
    <div className={classes.notFound}>
      <p>404</p>
      <p>Страница не найдена</p>
    </div>
  );

  return <div className={classes.container}>{text404}</div>;
};

export default NotFoundPage;
